// extracted by mini-css-extract-plugin
module.exports = {"card":"setGroup_card__GC2RI"};